import { render, staticRenderFns } from "./script-dialog.vue?vue&type=template&id=f4f9015e"
import script from "./script-dialog.vue?vue&type=script&lang=js"
export * from "./script-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports